module.exports = __webpack_public_path__ + "static/media/Biosina.a1903b20.jpg";